import React from 'react'
import { useCheckPolicy } from '../../../../hooks'
import { ADMIN_ROUTES } from '../../../../constants'
import CardTile from '../CardTile'
import Text from '../../../atoms/Text'

function StatusReportsHome () {
  const canViewStatusReports = useCheckPolicy('admin_view_status_templates')

  return (
    <div className='w-full flex-col gap-2 p-5 px-15'>
      <Text text='Status Report' variant='h1' className='pb-2' />
      <div className='py-2'>
        <div className='grid grid-cols-4 gap-2'>
          {canViewStatusReports && (
            <CardTile to={ADMIN_ROUTES.STATUS_REPORTS.TEMPLATES.HOME} icon='file' title='Manage Status Templates' />
          )}
          <CardTile to={ADMIN_ROUTES.STATUS_REPORTS.ASSIGNMENTS.HOME} icon='group' title='Manage Status Report Assignments' />
        </div>
      </div>
    </div>
  )
}

export default StatusReportsHome
